exports = module.exports = require("../../../../../../shared/frontend/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.ap-gallery__item[data-v-3082dcd4] {\n  overflow: hidden;\n  width: 60px;\n  height: 50px;\n  cursor: pointer;\n  margin-bottom: 12px;\n  margin-right: 12px;\n  display: inline-block;\n}\n.ap-gallery__item img[data-v-3082dcd4] {\n    width: auto;\n    height: auto;\n}\n.modal[data-v-3082dcd4] {\n  left: 50px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/css-loader?{"minimize":false,"sourceMap":false}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/style-compiler?{"id":"data-v-3082dcd4","scoped":true,"hasInlineConfig":true}!/home/alarmplan/staging/shared/frontend/~/sass-loader?{"sourceMap":false}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ApParts/ApGallery.vue
// module id = 787
// module chunks = 1